import { render } from "./workflow-review.vue?vue&type=template&id=399ecc1b&scoped=true"
import script from "./workflow-review.vue?vue&type=script&lang=js"
export * from "./workflow-review.vue?vue&type=script&lang=js"

import "./workflow-review.vue?vue&type=style&index=0&id=399ecc1b&lang=scss&scoped=true"

import exportComponent from "../../../../../../../../node_modules/rspack-vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-399ecc1b"]])

export default __exports__